import { hasWindow } from "./dom";
let g = {};
if (hasWindow()) {
    if (window.idpcGlobal) {
        g = window.idpcGlobal;
    }
    else {
        window.idpcGlobal = g;
    }
}
export const idpcState = () => g;
export const reset = () => Object.getOwnPropertyNames(g).forEach((p) => delete g[p]);
